<!--suppress CheckEmptyScriptTag -->
<template>
  <div>
    <q-form class="q-gutter-xs" ref="form">
      <div class="row">
        <q-input class="col" dense autofocus
                 v-model="value.contactName" label="Name"
                 :rules="[val => !!val.trim() || 'Name is required']" />
      </div>
      <div class="row">
        <q-input class="col" dense autofocus
                 v-model="value.contactLastname" label="Last name"
                 :rules="[val => !!val.trim() || 'Last name is required']" />
      </div>      
      <div class="row">
        <q-input class="col" dense
                 v-model="value.company" label="Company (Optional)"
                 :rules="[]"/>
      </div>
      <div class="row">
        <q-input class="col" dense
                 v-model="value.address" label="Address"
                 :rules="[val => !!val.trim() || 'Address is required']" />
      </div>
      <div class="row">
        <q-input class="col" dense
                 v-model="value.address2" label="Apartment, suite, etc. (Optional)"
                 :rules="[]"/>
      </div>
      <div class="row">
        <q-input class="col" dense
                 v-model="value.city" label="City"
                 :rules="[val => !!val.trim() || 'City is required']" />
      </div>
      <div class="row">
        <q-input class="col" dense
                 v-model="value.phoneNumber" label="PhoneNumber" mask="##-####-####" 
                 :rules="[ val => val && val.length == 12 || 'Phone number is required']" />
      </div>      
      <div>
        <div class="row q-col-gutter-md">
          <q-input class="col-4" dense
                   v-model="value.country" label="Country" :disable="true"
                   :rules="[val => !!val || 'Country is required']" />
          <q-select class="col-4" dense
                    v-model="value.state" label="State"
                    :options="filteredStateOptions" use-input fill-input hide-selected
                    @filter="filterFn" ref="state"
                    :rules="[val => !!val || 'State is required']" />
          <q-input class="col-4" dense
                   v-model="value.postCode" label="Postcode"
                   mask="####"
                   :rules="[val => !!val || 'Postcode is required',
                            val => val.length === 4 || 'Postcode must have 4 digits']"
                   lazy-rules />
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
// Would be nice to use this: https://github.com/gocanto/google-autocomplete
export default {
  name: 'ShippingDetails',
  props: {
    value: {
      contactName: String,
      company: String,
      address: String,
      address2: String,
      city: String,
      country: String,
      state: String,
      postCode: String,
      phone: String
    }
  },
  data () {
    return {
      stateOptions: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
      filteredStateOptions: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']
    }
  },
  methods: {
    async validate () {
      return this.$refs.form.validate()
    },
    abortFilterFn (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.options = this.stateOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
      }, ref => {
        if (val !== '' && ref.options.length > 0 && ref.optionIndex === -1) {
          ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
          ref.toggleOption(ref.options[ref.optionIndex], true) // toggle the focused option
        }
      })
    },
    filterFn (val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.filteredStateOptions = this.stateOptions.filter(v => v.toLowerCase().indexOf(needle) > -1)
        // this.$nextTick(() => {
        //   this.$refs.state.setOptionIndex(0)
        //   this.$refs.state.toggleOption(this.filteredStateOptions[0], true)
        // })
      })
    }
  }
}
</script>

<style scoped>

</style>
